import { render } from "./HowItWorksSection.vue?vue&type=template&id=68c809c1&scoped=true"
import script from "./HowItWorksSection.vue?vue&type=script&lang=js"
export * from "./HowItWorksSection.vue?vue&type=script&lang=js"

import "./HowItWorksSection.vue?vue&type=style&index=0&id=68c809c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c809c1"]])

export default __exports__